import { render, staticRenderFns } from "./LabProductManage.vue?vue&type=template&id=21b563e0&scoped=true"
import script from "./LabProductManage.vue?vue&type=script&lang=js"
export * from "./LabProductManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b563e0",
  null
  
)

export default component.exports